import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SearchButton extends Component {
  constructor(props) {
    super(props);
    this.handleSearchClick = this.handleSearchClick.bind(this);
  }

  handleSearchClick() {
    const {initialDate, finalDate, reason, partCode, agency, user, dealer} = this.props;
    this.props.fetchLostSalesReportDetail({
      initialDate, finalDate, reason, partCode, agency, user, dealer,
    });
  }

  render() {
    const {loading, loadingAgencies} = this.props;

    return (
      <Button primary
        content='BUSCAR'
        disabled={loadingAgencies || loading}
        loading={loading}
        onClick={this.handleSearchClick}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {loading, downloading} = state.lostSalesReportDetail;

  return {
    'loading': loading || downloading,
    'loadingAgencies': state.dealer.loading || state.dealer.loadingAgencies,
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
    'partCode': state.lostSalesReportDetail.partCode,
  };
};

const {fetchLostSalesReportDetail} = Actions;

export default connect(mapStateToProps, {fetchLostSalesReportDetail})(SearchButton);
